import React, { useEffect, useState } from "react";
import axios from "axios";
import { API_BASE_URL } from "../../services/Constants";

const RKMainHome = () => {

  const [activeTab, setActiveTab] = useState("enquiry");
  const [data, setData] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const limit = 5;

  const fetchData = async (pageNumber, tabType) => {
    try {
      setLoading(true);
      setError(null);

      const url =
        tabType === "enquiry"
          ? `${API_BASE_URL}/enquiry/getEnquiryList?page=${pageNumber}&limit=${limit}`
          : `${API_BASE_URL}/enquiry/getContactsInfo?page=${pageNumber}&limit=${limit}`;

      console.log("API URL:", url); // Debug

      const response = await axios.get(url);

      console.log("API Response:", response.data); // Debug

      setData(response?.data?.data || []);
      setTotalPages(response?.data?.totalPages || 1);

    } catch (err) {
      console.error("Fetch Error:", err);
      setError("Failed to load data");
      setData([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData(page, activeTab);
  }, [page, activeTab]);

  const handleTabChange = (tab) => {
    setActiveTab(tab);
    setPage(1);
    setData([]);
  };

  return (
    <div style={{ padding: "30px" }}>
      <h2>RK Farm Admin Dashboard</h2>

      {/* Tabs */}
      <div style={{ marginBottom: "20px" }}>
        <button
          onClick={() => handleTabChange("enquiry")}
          style={{
            marginRight: "10px",
            backgroundColor: activeTab === "enquiry" ? "#4CAF50" : "#ccc",
            color: "#fff",
            padding: "8px 15px",
            border: "none",
            cursor: "pointer"
          }}
        >
          Enquiries
        </button>

        <button
          onClick={() => handleTabChange("contact")}
          style={{
            backgroundColor: activeTab === "contact" ? "#4CAF50" : "#ccc",
            color: "#fff",
            padding: "8px 15px",
            border: "none",
            cursor: "pointer"
          }}
        >
          Contacts
        </button>
      </div>

      {/* Loading */}
      {loading && <p>Loading...</p>}

      {/* Error */}
      {error && <p style={{ color: "red" }}>{error}</p>}

      {/* Table */}
      {!loading && !error && (
        <table border="1" width="100%" cellPadding="10">
          <thead>
            <tr>
              {activeTab === "enquiry" ? (
                <>
                  <th>Name</th>
                  <th>Phone</th>
                  <th>Product</th>
                  <th>Quantity</th>
                  <th>Village</th>
                </>
              ) : (
                <>
                  <th>First Name</th>
                  <th>Last Name</th>
                  <th>Email</th>
                  <th>Phone</th>
                  <th>Message</th>
                </>
              )}
            </tr>
          </thead>
          <tbody>
            {data.length > 0 ? (
              data.map((item) => (
                <tr key={item.id}>
                  {activeTab === "enquiry" ? (
                    <>
                      <td>{item.name}</td>
                      <td>{item.phone}</td>
                      <td>{item.product}</td>
                      <td>{item.quantity}</td>
                      <td>{item.village}</td>
                    </>
                  ) : (
                    <>
                      <td>{item.first_name}</td>
                      <td>{item.last_name}</td>
                      <td>{item.email}</td>
                      <td>{item.phone}</td>
                      <td>{item.message}</td>
                    </>
                  )}
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="5" align="center">
                  No Data Found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      )}

      {/* Pagination */}
      {!loading && totalPages > 1 && (
        <div style={{ marginTop: "20px" }}>
          <button
            disabled={page === 1}
            onClick={() => setPage((prev) => prev - 1)}
          >
            Prev
          </button>

          <span style={{ margin: "0 15px" }}>
            Page {page} of {totalPages}
          </span>

          <button
            disabled={page === totalPages}
            onClick={() => setPage((prev) => prev + 1)}
          >
            Next
          </button>
        </div>
      )}
    </div>
  );
};

export default RKMainHome;
